const Notes = ["A", "A#", "B", "C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab"];

const DetermineHalfSteps = (input, ref) =>
    (12 * Math.log(input / ref)) / Math.log(2);

const DetermineNoteIndex = ({ half_steps }) => {
    if (Math.abs(half_steps) > 12) {
        const raw_idx = Math.round(half_steps) % 12;
        if (raw_idx < 0) {
            return 12 + raw_idx;
        }
        return raw_idx;
    }

    const n = Math.round(half_steps);
    if (n >= 0) return n;
    return 12 + n;
};

const DetermineOctave = ({ index, half_steps }) =>
    Math.ceil(half_steps / 12) + 4;

const DetermineDiff = ({ half_steps }) =>
    (Math.round((half_steps - Math.round(half_steps)) * 100) / 100);

export default {
    Notes,
    DetermineDiff,
    DetermineHalfSteps,
    DetermineNoteIndex,
    DetermineOctave,
};
